import { render } from "./TodoItem.vue?vue&type=template&id=30f092c1&scoped=true"
import script from "./TodoItem.vue?vue&type=script&lang=js"
export * from "./TodoItem.vue?vue&type=script&lang=js"

import "../styles/todo.css?vue&type=style&index=0&id=30f092c1&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f092c1"]])

export default __exports__